import Image from 'app/Components/Shared/Image/image';
import React, {ReactElement, useContext, useState, useRef} from 'react';
import BuisnessInvoicesContext from './BusinessInvoicesContext';
import useOnClickOutside from 'app/utilities/hooks/useOnClickOutside';
import {Container} from 'reactstrap';

type BusinessInvoicesHeaderProps = {
  title: string;
  subtitle: string;
  faq: ReactElement;
};

const Modal = ({onClose, component}: {component: ReactElement; onClose(): void}) => {
  const ref = useRef();
  useOnClickOutside(ref, (outside) => outside && onClose());
  return (
    <div className='BusinessInvoicesPage__modal__backdrop'>
      <div className='BusinessInvoicesPage__modal__container' ref={ref}>
        <button className='BusinessInvoicesPage__modal__close' onClick={onClose}>
          <Image src={require('./images/icons-x.svg')} />
        </button>
        {component}
      </div>
    </div>
  );
};

const BusinessInvoicesHeader = ({title, subtitle, faq}: BusinessInvoicesHeaderProps) => {
  const [{invoices}, dispatch] = useContext(BuisnessInvoicesContext);
  const [showFaq, setShowFaq] = useState(false);
  return (
    <Container>
      <div className='BusinessInvoicesPage__head'>
        <div
          className='BusinessInvoicesPage__head__info'
          onClick={() => {
            dispatch({type: 'faq', status: 'show'});
            setShowFaq(true);
          }}>
          <Image src={require('./images/icons-info.svg')} />
          <span>עזרה?</span>
        </div>

        <h1 className='BusinessInvoicesPage__head__title'>{title}</h1>
        {!invoices && (
          <>
            <h3 className='BusinessInvoicesPage__head__subtitle'>{subtitle}</h3>
            <Image className='BusinessInvoicesPage__head__image' src={require('./images/icons-invoice.svg')} />
          </>
        )}
        {showFaq && <Modal component={faq} onClose={() => setShowFaq(false)} />}
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    Component: state.faq,
  };
};

export default BusinessInvoicesHeader;
